import React from "react";
import { createRoot } from "react-dom/client";

import * as Sentry from "@sentry/react";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";

import { initSentry } from "@/lib/sentry";

import App from "./App";

initSentry();

// Windows' system emoji font (Segoe UI Emoji) ships no country-flag glyphs, so
// ISO-code flag emoji render as bare letters in Chromium browsers (Brave, Chrome,
// Edge). This detects those platforms and injects a flag-only fallback @font-face
// — scoped by unicode-range, so it only ever provides flag codepoints — pointing
// at a locally-vendored woff2 (no runtime CDN/CSP dependency). Firefox, macOS and
// Linux render flags natively, so the polyfill injects nothing there and their
// native flags are preserved. The font name is added to --font-sans in App.css so
// these glyphs actually resolve to it.
polyfillCountryFlagEmojis(
  "Twemoji Country Flags",
  "/fonts/TwemojiCountryFlags.woff2",
);

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
